import { render, staticRenderFns } from "./OrderCreate.vue?vue&type=template&id=0e039fb0&"
import script from "./OrderCreate.vue?vue&type=script&lang=js&"
export * from "./OrderCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e039fb0')) {
      api.createRecord('0e039fb0', component.options)
    } else {
      api.reload('0e039fb0', component.options)
    }
    module.hot.accept("./OrderCreate.vue?vue&type=template&id=0e039fb0&", function () {
      api.rerender('0e039fb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/App/VPL/MyOrder/OrderCreate.vue"
export default component.exports